/* eslint-disable max-len */
define({
    root: ({
        ok: 'OK',
        cancel: 'Cancel',
        standardColors: 'Standard Colors',
        customColors: 'Custom Colors',
        recentColors: 'Recent Colors',
        preview: 'Preview',
        redTitle: 'R', // Used for label for three edit fields to enter [R, G, B] color
        greenTitle: 'G', // Used for label for three edit fields to enter [R, G, B] color
        blueTitle: 'B', // Used for label for three edit fields to enter [R, G, B] color
        hexTitle: 'Hex', // Used for label for to enter hex color
        hueTitle: 'H', // Used for label for three edit fields to enter [H, S, V] color
        saturationTitle: 'S', // Used for label for three edit fields to enter [H, S, V] color
        valueTitle: 'V', // Used for label for three edit fields to enter [H, S, V] color
        doubleLabel: 'RGB [0-1]',
        intLabel: 'RGB [0-255]',
        hexLabel: 'Hex',
        hsvLabel: 'HSV',
        auto: 'Auto',
        none: 'None',
        flat: 'Flat',
        interp: 'Interp',
        texturemap: 'Texturemap',
        invalidHexErrorMessage: 'Value must be in a valid hexadecimal form.'
    }),
    'ja-jp': true,
    'zh-cn': true,
    'ko-kr': true
});
